/*
 * Converts a Paysafe error code into a Stripe error code (our standard)
 *
 * Currently the Stripe error handling has not been implemented so this service actually
 * just converts to human-readable strings.
 */
let paymentErrorService = () => {
  const formatError = error => {
    let message = '';
    let defaultMessage = 'Please check your card details and try again or contact us for help.';

    if (!error || !error.code) {
      return defaultMessage;
    }

    switch (error.code) {
    case 'neverload':
      message = 'There is a problem with the payment gateway please contact us to complete your order.';
      break;
    case '3002':
    case '3005':
    case '3006':
    case '5068':
      message = 'The card details provided may not be correct, please try again.';
      break;
    case '3009':
    case '3011':
    case '3012':
    case '3013':
    case '3014':
    case '3016':
    case '3022':
    case '3023':
    case '3024':
    case '3032':
    case '3035':
      message = 'The issuing bank has declined your transaction.';
      break;
    case '3036':
    case '3037':
    case '3038':
    case '3039':
    case '3046':
    case '3047':
    case '3048':
    case '3054':
    case '5021':
      message = 'Your transaction was denied.';
      break;
    case '9003':
    default:
      message = defaultMessage;
      break;
    }

    return message;
  };
  
  return {
    formatError
  };
}

paymentErrorService.$inject = [];

export default paymentErrorService;


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/journey-ui/payment/services/paysafe.error.service.js